<template>
  <transition name="fade">
    <div class="uid-token popup" v-if="visible">
      <div class="uid-token-shadow"></div>
      <div class="uid-token-main">
        <a
          href="javascript:;"
          class="uid-token-main-close"
          @click="hideUidTokenLoginPopup"
        ></a>
        <uid-token-login
          class="uid-token-main-content"
          :isPopupMode="true"
          :popupModeTitle="popupModeTitle"
          :uidNum="uidNum"
          :defaultUid="uid"
          @loginSuccess="loginSuccess"
        ></uid-token-login>
        <div class="choose-other">
          <a
            href="JavaScript:;"
            class="choose-other-text"
            @click="hideUidTokenLoginPopup"
            >{{ letter.chooseOtherPay }}</a
          >
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import UidTokenLogin from './UidTokenLogin.vue';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      uid: state => state.login.uid
    }),
    ...mapGetters(['getCoinsName']),
    uidNum() {
      return [2].includes(+this.gameId) ? 6 : 4;
    },
    popupModeTitle() {
      return this.letter.coinsPayTokenLogin.replace(
        '\${Z-BIT}',
        this.getCoinsName
      );
    }
  },
  methods: {
    hideUidTokenLoginPopup() {
      this.$emit('update:visible', false);
    },
    loginSuccess() {
      this.hideUidTokenLoginPopup();
    }
  },
  components: {
    UidTokenLogin
  }
};
</script>

<style lang="scss" scoped>
.uid-token {
  &.popup {
    overflow: auto;
    z-index: 21;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
    transform: scale3d(1, 1, 1) translateZ(0) !important;
    transition: 0 !important;
  }
  &-main {
    box-sizing: border-box;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    padding-top: 48px;
    transform: translate(-50%, -50%);
    background-position: center;
    background-repeat: no-repeat;
    @psetbg ('uid-token-login-popup-bg.png');
    background-size: 100% 100%;

    &-close {
      position: absolute;
      right: 46px;
      top: 36px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('close.png');
    }
  }
  .choose-other {
    display: block;
    margin: 22px auto 0;
    text-align: center;
    &-text {
      display: inline-block;
      padding-bottom: 4px;
      border-bottom: 1px solid var(--login-uidtoken-input-title);
      font-size: 30px;
      color: var(--login-uidtoken-input-title);
    }
  }
}

::v-deep .uid-token-title {
  display: block;
  padding: 0 36px;
  margin-bottom: 36px;
}

::v-deep .uid-token-main-content {
  width: 100%;
  background-image: unset !important;
}
</style>
